import React from "react";
import { Link } from "react-router-dom";
import Layout from "@/components/Layout";
import { Button } from "@/components/ui/button";

export default function NotFound() {
  return (
    <Layout>
      <section
        className="max-w-3xl mx-auto px-6 py-24 text-center"
        data-testid="not-found-page"
      >
        <div className="text-[10px] uppercase tracking-[0.24em] font-bold text-[var(--rg-sage)] mb-3">404</div>
        <h1 className="font-heading font-extrabold text-4xl sm:text-5xl text-[var(--rg-text-strong)] mb-4">Page not found</h1>
        <p className="text-[var(--rg-text)] text-base mb-10 max-w-xl mx-auto leading-relaxed">
          The page you are looking for does not exist or has been moved.
        </p>

        <div className="flex flex-wrap gap-3 justify-center">
          <Link to="/" data-testid="not-found-cta-home">
            <Button
              size="lg"
              className="bg-[var(--rg-sage)] text-[var(--rg-on-sage)] hover:bg-[var(--rg-sage-hover)] font-bold"
            >
              Go to Home
            </Button>
          </Link>
          <Link to="/demo" data-testid="not-found-cta-demo">
            <Button
              size="lg"
              variant="outline"
              className="border-[var(--rg-border)] text-[var(--rg-text-strong)] hover:bg-[var(--rg-surface)] font-semibold"
            >
              View Demo
            </Button>
          </Link>
        </div>
      </section>
    </Layout>
  );
}
